'use strict';

class ReportFormOrderConfirmation {
  constructor($scope, $location, reportService, Notification) {
    this.$scope = $scope;
    this.$location = $location;
    this.reportService = reportService;
    this.Notification = Notification;
  }

  $onInit() {
    this.results = {};
    this.columns = [];
    this.selectedColumns = [];
    this.params = {
      columns: [],
      from: moment().startOf('month').format('DD.MM.YY'),
      to: moment().endOf('month').format('DD.MM.YY'),
      format: 'JSON'
    };
    this.format = 'XLS';

    this.loadColumns();
  }

  checkType(val) {
    return this.reportService.checkType(val);
  }

  preview() {
    if (this.params.columns.length) {
      let params = {
        columns: this.params.columns.join(','),
        from: moment(this.params.from, 'DD.MM.YY').format('YYYY-MM-DD'),
        to: moment(this.params.to, 'DD.MM.YY').format('YYYY-MM-DD'),
        format: 'JSON'
      };

      this.reportService.generate('orderConfirmations', params)
        .then((resp) => {
          if (resp.status === 204) {
            this.results = [];
            this.Notification.info('Det var ingen ordrebekreftelser i valgt periode.');
          } else {
            this.results = resp.data;
          }
        });
    }
  }

  loadColumns() {
    this.columns = [];

    this.reportService.availableColumns('orderConfirmations')
      .then((resp) => {
        this.columns = resp.data;
        this.results = {};

        // preselect
        this.selectedColumns = [];
        resp.data.forEach((c) => {
          this.selectColumn(c.key);
        }, this);
      });
  }

  selectColumn(key) {
    if ($.inArray(key, this.selectedColumns) === -1) {
      this.selectedColumns.push(key);
    } else {
      let index = this.selectedColumns.indexOf(key);
      this.selectedColumns.splice(index, 1);
    }

    angular.extend(this.params, {
      columns: this.selectedColumns
    });
  }

  download(format, email = false) {
    let params = {
      format: format,
      columns: this.selectedColumns.join(','),
      from: moment(this.params.from, 'DD.MM.YY').format('YYYY-MM-DD'),
      to: moment(this.params.to, 'DD.MM.YY').format('YYYY-MM-DD')
    };

    if (email) {
      params.email = this.email;
    }

    this.reportService.download('orderConfirmations', params, email)
      .then((resp) => {
        if (resp) {
          this.Notification.success(`Rapporten er sendt til ${this.email}`);
        }
      });
  }
}

ReportFormOrderConfirmation.$inject = ['$scope', '$location', 'reportService', 'Notification'];

const reportFormOrderConfirmation = {
  bindings: {
    email: '<'
  },
  controller: ReportFormOrderConfirmation,
  template: `
    <h2>Ordrebekreftelser</h2>

    <div report-generator ng-model="$ctrl.params"></div>

    <div class="row">
      <div class="large-6 columns">
        <fieldset>
          <label for="format">Format</label>
          <select id="format" ng-model="$ctrl.format">
            <option value="CSV">CSV</option>
            <option value="XLS">Excel</option>
          </select>
        </fieldset>
      </div>

      <div class="large-6 columns">
        <fieldset>
          <label for="email">E-postadresse</label>
          <input id="email" name="email" type="email" ng-model="$ctrl.email">
        </fieldset>
      </div>
    </div>

    <button ng-click="$ctrl.preview()" class="button">Vis</button>

    <div ng-show="$ctrl.results.items.length">
      <a href ng-click="$ctrl.download($ctrl.format)" class="button secondary"><i class="fa fa-file-o"></i> Last ned</a>

      <a ng-show="$ctrl.email" href ng-click="$ctrl.download($ctrl.format, true)" class="button secondary"><i class="fa fa-envelope-o"></i> Send på e-post</a>

      <table class="responsive">
        <thead>
          <tr>
            <th ng-repeat="(key, value) in $ctrl.results.headers" ng-bind="value"></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="item in $ctrl.results.items track by $index">
            <td class="nowrap" ng-repeat="(key, value) in item" ng-if="key !== '_links'">
              <a href="#/ordrebekreftelse/{{ value }}" ng-if="key === 'orderConfirmationNumber'">{{ value }}</a>
              <span ng-if="key !== 'orderConfirmationNumber'" ng-bind="$ctrl.checkType(value, key)"></span>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr ng-repeat="item in $ctrl.results.items | limitTo:1 track by $index">
            <th class="nowrap" ng-repeat="(key, value) in item" ng-bind="$ctrl.checkType($ctrl.results.summary[key])"></th>
          </tr>
        </tfoot>
      </table>
    </div>
  `
};

angular
  .module('SendRegning')
  .component('reportFormOrderConfirmation', reportFormOrderConfirmation)
  .config(($routeProvider) => {
    $routeProvider
      .when('/rapport/ordrebekreftelse', {
        title: 'Ordrebekreftelser',
        template: '<report-form-order-confirmation email="$resolve.email" />',
        secure: true,
        resolve: {
          email: (originatorService) => originatorService.get().then((resp) => resp.data.contact.email)
        }
      });
  });
